import React, { useContext } from 'react'

import SaveCuratedTripItemButton from 'tripPlanner/components/Buttons/SaveCuratedTripItemButton'
import SavePublicTripItemButton from 'tripPlanner/components/Buttons/SavePublicTripItemButton'
import TripContext, { TripContextValue } from 'tripPlanner/contexts/TripContext'
import { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
  className?: string
}

function SaveTripItemButton({ item, className }: Props) {
  const context = useContext<TripContextValue | null>(TripContext)

  if (!context) return null

  const tripId = context.tripId || item.tripId
  const isTemplate = context.viewAsTemplate
  const isPublicTrip = context.isPublicTrip

  return (
    <>
      {isPublicTrip && tripId && (
        <SavePublicTripItemButton
          item={item}
          tripId={tripId}
          className={className}
        />
      )}
      {isTemplate && tripId && (
        <SaveCuratedTripItemButton
          item={item}
          tripId={tripId}
          className={className}
        />
      )}
    </>
  )
}

export default SaveTripItemButton
